(function () {
  const MOBILE_MAX = 760;

  function isMobile(): boolean {
    return window.innerWidth <= MOBILE_MAX;
  }

  // True on touch screens and tablets — hover is unreliable
  function isTouchDevice(): boolean {
    return window.matchMedia('(hover: none)').matches;
  }

  function usesClick(): boolean {
    return isMobile() || isTouchDevice();
  }

  function positionDropdown(li: HTMLElement, dropdown: HTMLElement): void {
    // Always full-width below the nav bar
    const nav = li.closest('.top-product-nav');
    if (!nav) return;
    const navRect = nav.getBoundingClientRect();
    dropdown.style.top = navRect.bottom + 'px';
    dropdown.style.left = '0px';
    dropdown.style.right = '0px';
    dropdown.style.width = '100vw';
  }

  function openDropdown(li: HTMLElement): void {
    const dropdown = li.querySelector<HTMLElement>('.top-product-nav__dropdown');
    if (!dropdown) return;
    dropdown.removeAttribute('hidden');
    positionDropdown(li, dropdown);
  }

  function closeDropdown(li: HTMLElement): void {
    const dropdown = li.querySelector<HTMLElement>('.top-product-nav__dropdown');
    if (dropdown) dropdown.setAttribute('hidden', '');
    li.classList.remove('is-open');
  }

  function closeAll(): void {
    document.querySelectorAll<HTMLElement>('.top-product-nav__item--has-children').forEach(closeDropdown);
  }

  document.querySelectorAll<HTMLElement>('.top-product-nav__item--has-children').forEach((li) => {
    let closeTimer: ReturnType<typeof setTimeout> | null = null;
    const dropdown = li.querySelector<HTMLElement>('.top-product-nav__dropdown');
    const anchor = li.querySelector<HTMLElement>(':scope > a');

    // Touch/mobile: click toggles submenu instead of navigating
    if (anchor) {
      anchor.addEventListener('click', (e) => {
        if (!usesClick()) return;
        e.preventDefault();
        const wasOpen = li.classList.contains('is-open');
        closeAll();
        if (!wasOpen) {
          li.classList.add('is-open');
          openDropdown(li);
        }
      });
    }

    // Hover-capable devices only
    li.addEventListener('mouseenter', () => {
      if (usesClick()) return;
      if (closeTimer !== null) clearTimeout(closeTimer);
      openDropdown(li);
    });

    li.addEventListener('mouseleave', () => {
      if (usesClick()) return;
      closeTimer = setTimeout(() => closeDropdown(li), 150);
    });

    // Keep dropdown open when pointer moves into it
    if (dropdown) {
      dropdown.addEventListener('mouseenter', () => {
        if (usesClick()) return;
        if (closeTimer !== null) clearTimeout(closeTimer);
      });
      dropdown.addEventListener('mouseleave', () => {
        if (usesClick()) return;
        closeTimer = setTimeout(() => closeDropdown(li), 150);
      });
    }
  });

  // Close dropdown on outside click (touch/mobile only)
  document.addEventListener('click', (e) => {
    if (!usesClick()) return;
    if (!(e.target as HTMLElement).closest('.top-product-nav__item--has-children')) {
      closeAll();
    }
  });

  // Reposition on scroll (fixed positioning follows the viewport, not the page)
  window.addEventListener('scroll', () => {
    document.querySelectorAll<HTMLElement>('.top-product-nav__item--has-children').forEach((li) => {
      const dropdown = li.querySelector<HTMLElement>('.top-product-nav__dropdown');
      if (dropdown && !dropdown.hasAttribute('hidden')) {
        positionDropdown(li, dropdown);
      }
    });
  }, { passive: true });
})();
